import { SignUpAppHeader } from '@truvity/js-core__uikit';

import { HomeActiveLink } from './HomeActiveLink';

export const AppHeader = () => <SignUpAppHeader LogoWrapper={HomeActiveLink} />;
